<template>
	<div id="postlive" class="bg-white">
		<b-container class="py-md-5">
			<b-row align-v="center">
				<b-col 	cols="12"
						lg="auto"
						class="py-4"
						:class="postliveQa() ? 'mw-lg-50' : null">
					<div class="p-5 p-md-0 rounded" :class="[asset.text_color ? 'text-'+asset.text_color : 'text-dark']">
						<h3 v-html="makeBr(asset.title)"></h3>
						<p class="lead m-0 pt-4" v-html="makeBr(asset.description)" v-if="asset.description"></p>
						<div class="line pt-3" v-if="asset.description"></div>
						<p class="lead m-0 pt-3" v-html="makeBr(asset.postlive)" v-if="asset.postlive"></p>
					</div>
				</b-col>
				<b-col 	cols="12"
						lg="auto"
						class="ml-auto mw-lg-50"
						v-if="postliveQa()">
					<Ask />
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
	import Ask from '@/components/asset/Ask.vue'
	export default {
		computed: {
			asset() {
				return this.$store.getters.asset
			}
		},
		components: {
			Ask
		},
		methods: {
			postliveQa() {
				if(this.asset.asset_qa && this.asset.asset_qa.enabled && this.asset.asset_qa.postlive) return true
				return false
			},
			makeBr(text) {
				return text.replace('\n', '<br>')
			}
		}
	}
</script>
